import { AlertTitle } from "@mui/material";
import React from "react";

import { EnhancedCustomer } from "../../../../../Models/Customer";
import CollapsingAlert from "../../../../Components/CollapsingAlert";

export const classNames = {
  alert: "customerInvalidDispositionAlert"
};

export interface ICustomerInvalidDispositionAlert {
  /** The customer that is assigned to the current session. */
  customer: EnhancedCustomer;
}

/** A disposition warning that warns the user about limited dispositions when the customer's primary properties have errors. */
const CustomerInvalidDispositionAlert: React.FC<ICustomerInvalidDispositionAlert> = ({ customer }) => {
  const invalidPrimaryInfoProperties = EnhancedCustomer.getInvalidPrimaryInfoItems(customer);
  return (
    <CollapsingAlert
      className={classNames.alert}
      show={Boolean(invalidPrimaryInfoProperties.length)}
      severity="warning"
    >
      <AlertTitle>Dispositions are limited because the customer is missing the following information:</AlertTitle>
      {invalidPrimaryInfoProperties.join(", ")}
    </CollapsingAlert>
  );
};

export default CustomerInvalidDispositionAlert;
